import { render } from "./PhysicianProfileView.vue?vue&type=template&id=80e873c0"
import script from "./PhysicianProfileView.vue?vue&type=script&lang=js"
export * from "./PhysicianProfileView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/physicians/PhysicianProfileView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "80e873c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('80e873c0', __exports__)) {
    console.log('reload')
    api.reload('80e873c0', __exports__)
  }
  
  module.hot.accept("./PhysicianProfileView.vue?vue&type=template&id=80e873c0", () => {
    console.log('re-render')
    api.rerender('80e873c0', render)
  })

}


export default __exports__